module.exports = __webpack_public_path__ + "static/media/JourneyToWellness(1).dacf4b2d.pdf";